export default {
    label_task:{
        en:"Trial Stations",
        bn:'ব্যবহারকারীরা'
    },
    label_new_task:{
        en:"New Trial Station",
        bn:'নতুন ব্যবহারকারী'
    },
    label_edit_task:{
        en:"Edit Trial Station",
        bn:'সম্পাদনা ব্যবহারকারী'
    },
    label_details_task:{
        en:"Details of Trial Station",
        bn:'ব্যবহারকারীর বিবরণ'
    },
}